import { render } from "./ScSeparator.vue?vue&type=template&id=e5c91e72&scoped=true"
import script from "./ScSeparator.vue?vue&type=script&lang=js"
export * from "./ScSeparator.vue?vue&type=script&lang=js"

import "./ScSeparator.vue?vue&type=style&index=0&id=e5c91e72&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5c91e72"]])

export default __exports__